const doc = [({"usage":"How to Use", "setting":"How to Setting", "download":"Software Download", "install":"How to install"})];
module.exports = doc.length <= 1 ? doc[0] : doc;